module.exports = __webpack_public_path__ + "static/media/excellentSuccess.66b32495.webp";